import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import ChangePasswordView from 'views/betShopManagement/configuration/changePassword/changePasswordView'; // Importing ChangePasswordView component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the change password view for bet shop management.
 * @extends JetView
 */
export default class changePasswordBetShopView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applying theme to the toolbar
                    elements: [
                        {
                            view: 'label', // Label component
                            label: _('Cambiar Contraseña'), // Translated label text
                            width: 300, // Width of the label
                        },
                    ],
                },
                ChangePasswordView, // Including ChangePasswordView component
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Check permissions for accessing the change password menu
        if (!devConfig.getPermAction('betShopManagementConfigurationChangePasswordMenu', 'Menu')) {
            this.show('./betShopManagement.configuration.generateToken'); // Redirect if no permission
        } else {
            return {
                type: 'wide', // Layout type
                cols: [left], // Columns configuration
            };
        }
    }
}

// FILE DOCUMENTED
